import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "../src/assets/fonst/fonts.css"
import reportWebVitals from "./reportWebVitals";
import { Toaster } from "react-hot-toast";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.Fragment>
    <App />

    <Toaster
      position="top-right"
      reverseOrder={false}
      toastOptions={{
        className: "text-[14px]",
        style: {
          background: "#313049",
          color: "#FFFFFF",
        },
      }}
    />
  </React.Fragment>
);

reportWebVitals();
